export var NOTIFICATION_RENDER_START_PERFORMANCE_MARK = 'notification.list.render.start';